<script>
import UserProfile from './view/user/Profile.vue'
import UserForm from './view/user/Form.vue'
import AgencyProfile from './view/agency/Profile.vue'
import AgencyForm from './view/agency/Form.vue'

export default {
  name: 'MyAgency',
  components: {
    UserProfile,
    UserForm,
    AgencyProfile,
    AgencyForm
  },
  metaInfo: {
    title: 'Мое агенство'
  },
  computed: {
    userFormIsShown() {
      return this.$store.getters['myAgency/showUserForm']
    },
  },
  methods: {
    showUserForm() {
      this.$store.commit('myAgency/changeShowUserForm', true)
    },
    hideUserForm() {
      this.$store.commit('myAgency/changeShowUserForm', false)
    }
  }
}
</script>

<template>
  <div class="my-agency">
    <div class="my-agency__block">
      <h2 class="my-agency__title">
        Профиль пользователя
      </h2>
      <user-profile
        v-if="!userFormIsShown"
      />
      <user-form
        v-show="userFormIsShown"
      />
    </div>
    <div class="my-agency__block">
      <h2 class="my-agency__title">
        Данные компании
      </h2>
      <div class="my-agency__content">
        <agency-form />
        <agency-profile />
      </div>
    </div>
  </div>
</template>